import { useContext } from 'react'
import _isEmpty from 'lodash/isEmpty'
import _flatten from 'lodash/flatten'
import SlotDateContext from 'context/ProviderBooking/SlotDate'
import ProviderSlotContext from 'context/ProviderBooking/ProviderSlots'
import { ProviderFilterTypes } from 'dataSource/ProviderSearch'
import useAppSelector from 'hooks/useAppSelector'
import { parseProviderDataWithSlots } from './helper'
import { useRouter } from 'next/router'
import { TimeOfDay } from 'constants/common'

type UseShownSlotsProps = (
  slotsRowLimit?: number,
  providersList?: Provider[],
  slotDateData?: SlotDateType,
  providerSlotData?: ProviderScheduleDetails,
  timeZone?: string
) => {
  providerCardDetails: ProviderCardDetails[]
  countDetails: CountDetails
  slotDateData?: SlotDateType
  providerSlotData?: ProviderScheduleDetails
}

const useShownSlots: UseShownSlotsProps = (
  slotsRowLimit = 0,
  providersList = [],
  slotDateData,
  providerSlotData,
  timeZone
) => {
  const { query } = useRouter()
  const { startSlotDate, slotListLimit } =
    slotDateData || useContext(SlotDateContext)
  const { globalGroupedFilters } = useAppSelector((state) => state.global)
  const counselingTypedFilters =
    globalGroupedFilters[ProviderFilterTypes.COUNSELING_TYPE]
  const {
    error,
    loading: areSlotsLoading,
    nextAvailabilityForProviders,
    providerSlots,
  } = providerSlotData || useContext(ProviderSlotContext)

  const timeOfDayInQuery = query['timeOfDay[]']
  const timeOfDay = timeOfDayInQuery
    ? ((Array.isArray(timeOfDayInQuery)
        ? timeOfDayInQuery
        : [timeOfDayInQuery]) as TimeOfDay[])
    : undefined

  return parseProviderDataWithSlots({
    providerSlots,
    providersList,
    nextAvailabilityForProviders,
    startSlotDate,
    slotListLimit,
    counselingTypedFilters,
    slotsRowLimit,
    error,
    areSlotsLoading,
    timeOfDay,
    timeZone,
  })
}

export default useShownSlots
